(function($){

	OH.settings.vueDefine = (function(){
		var define = new Object();
		var lang = document.documentElement.getAttribute("lang");
		var estimateNullValues = {
			min : 0,
			max : 999999
		};

		var initialExp = (function(language){
			return (!language || language == "ja") ? [
				{ label : "あ行", exp : /[あ-おア-オヴ]/ },
				{ label : "か行", exp : /[か-ごカ-ゴ]/ },
				{ label : "さ行", exp : /[さ-ぞサ-ゾ]/ },
				{ label : "た行", exp : /[た-どタ-ド]/ },
				{ label : "な行", exp : /[な-のナ-ノ]/ },
				{ label : "は行", exp : /[は-ぽハ-ポ]/ },
				{ label : "ま行", exp : /[ま-もマ-モ]/ },
				{ label : "や行", exp : /[や-よヤ-ヨ]/ },
				{ label : "ら行", exp : /[ら-ろラ-ロ]/ },
				{ label : "わ行", exp : /[わ-んワ-ン]/ }
			] : [
				{ label : "A - D", exp : /[a-d]/i },
				{ label : "E - H", exp : /[e-h]/i },
				{ label : "I - L", exp : /[i-l]/i },
				{ label : "M - P", exp : /[m-p]/i },
				{ label : "Q - U", exp : /[q-u]/i },
				{ label : "V - Z", exp : /[v-z]/i }
			];
		})(lang);
		
		var baseRefiner = {
			seek_array : function(data, value, prop, prefix){
				prefix = !!prefix ? prefix : "";
				value += "";
				if(value == OH.idPrefix){
					value = "";
				}
				else if(value.indexOf(prefix) == 0){
					value = value.slice(prefix.length) - 0;
				}

				if(value === "" || value === null){
					return data;
				}

				var result = new Array();
				
        //data検索のマッチを格納
				for(var i=0; i<data.length; i++){
					if(data[i][prop].indexOf(value) >= 0){
						result.push(data[i]);
					}
				}
				return result;
			},
/*
			range : function(data, value, prop, prop_min, prop_max, nullValues){
				if(value == OH.idPrefix || value === "" || value === null){
					return data;
				}
				var result = new Array();
				value -= 0;
				for(var i=0; i<data.length; i++){
					if(data[i][prop][prop_min] == nullValues.min && data[i][prop][prop_max] == nullValues.max){
						continue;
					}
					if(data[i][prop][prop_min] <= value && data[i][prop][prop_max] >= value){
						result.push(data[i]);
					}
				}
				return result;
			},
*/
			match : function(data, expIndex, prop){
				if(expIndex === "" || expIndex === null){
					return data;
				}
				var result = new Array();
				for(var i=0; i<data.length; i++){
					if(!initialExp[expIndex] || initialExp[expIndex].exp.test(data[i][prop])){
						result.push(data[i]);
					}
				}
				return result;
			},
			equal : function(data, value, prop, prefix){
				prefix = !!prefix ? prefix : "";
				
				if(!(value instanceof Array)){
					value = [ value ];
				}
				
				for(var i=0; i<value.length; i++){
						
					value[i] += "";

					if(value[i] == OH.idPrefix){
						value[i] = "";
					}
					else if(value[i].indexOf(prefix) == 0){
						value[i] = value[i].slice(prefix.length) - 0;
					}

					if(value[i] === "" || value[i] === null){
						return data;
					}
					value[i] -= 0;
				}
				var result = new Array();

				for(var i=0; i<data.length; i++){
					if(value.indexOf(data[i][prop]) >= 0){
						result.push(data[i]);
					}
				}
				return result;
			},
/* 期間
			term : function(data, typeIndex, beginProp, endProp, datesProp){
				if(typeIndex === "" || typeIndex === null){
					return data;
				}
				var result = new Array();
				typeIndex -= 0;
				for(var i=0; i<data.length; i++){
					if(!terms[typeIndex] || terms[typeIndex].within(data[i][datesProp], data[i][beginProp], data[i][endProp], data[i].id)){
						result.push(data[i]);
					}
				}
				return result;
			},
*/
			date : function(data, value){
				var result = new Array();
				for(var i=0; i<data.length; i++){
					if(data[i].dates.indexOf(value) > -1){
						result.push(data[i])
					}
				}
				return result;
			}
		};

		define.rendering = {
			restaurants : {
				estimates : [ 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 15000 ],
				initialexp : initialExp
			},
			services : {
				initialexp : initialExp
			},
			shops : {
				initialexp : initialExp
			},
			events : {
//				terms : terms
			}
		};
		
		var defaultModel = {
			restaurants : { cat : OH.idPrefix, opt : OH.idPrefix, est : OH.idPrefix, ini : OH.idPrefix },
			services    : { cat : OH.idPrefix, ini : OH.idPrefix },
			shops       : { cat : OH.idPrefix, ini : OH.idPrefix },
			events : { date : (function(today){
				var zeroPadding = function(num, length){
					return (new Array(length).join("0") + num).slice(-length);
				};
				return today.getFullYear() + "" + zeroPadding(today.getMonth() + 1, 2) + "" + zeroPadding(today.getDate(), 2);
			})(new Date()) }
		}
		
		define.models = JSON.parse(JSON.stringify(defaultModel));
		define.modified = function(target, prop, value){
			return defaultModel[target][prop] != value;
		};
		define.defaultValue = function(target, prop){
			return defaultModel[target][prop];
		};

		define.refiners = {
			restaurants : {
				cat : function(data, value, def){
					return baseRefiner.seek_array(data, value, "cats", OH.idPrefix);
				},
				opt : function(data, value, def){
					return baseRefiner.seek_array(data, value, "opts", OH.idPrefix);
				},
				est : function(data, value, def){
					var noprefixValue = value.replace(OH.idPrefix, "");
					var values = (!!def["ests"].join && !!def["ests"].join[noprefixValue]) ? (function(){
						var base = [ value ];
						for(var i=0; i<def["ests"].join[noprefixValue].length; i++){
							base.push(def["ests"].join[noprefixValue][i]);
						}
						return base;
					})() : value;
					
					return baseRefiner.equal(data, values, "est", OH.idPrefix);
				},
				ini : function(data, value, def){
					return baseRefiner.match(data, value, (!lang || lang == "ja") ? "jp" : "en");
				},
				area : function(data, value, def){
					return baseRefiner.equal(data, value, "area", OH.idPrefix);
				}
			},
			services : {
				cat : function(data, value, def){
					return baseRefiner.seek_array(data, value, "cats", OH.idPrefix);
				},
				ini : function(data, value, def){
					return baseRefiner.match(data, value, (!lang || lang == "ja") ? "jp" : "en");
				},
				area : function(data, value, def){
					return baseRefiner.equal(data, value, "area", OH.idPrefix);
				}
			},
			shops : {
				cat : function(data, value, def){
					return baseRefiner.seek_array(data, value, "cats", OH.idPrefix);
				},
				ini : function(data, value, def){
					return baseRefiner.match(data, value, (!lang || lang == "ja") ? "jp" : "en");
				},
				area : function(data, value, def){
					return baseRefiner.equal(data, value, "area", OH.idPrefix);
				}
			},
			events : {
				date : function(data, value, def){
					return baseRefiner.date(data, value);
				}
			}
		};
		
		define.dataPrefix = function(type){
			if(type == "date"){
				return "";
			}
			return OH.idPrefix;
		};

		define.queryFilter = function(query){
			var idTypeKeys = ["cat", "area"];

			if(idTypeKeys.indexOf(query[0]) >= 0){
				query[1] = (!!query[1] ? OH.idPrefix : "") + query[1];
			}

			return query;
		};

		define.additionalFilters = {
			jpcurrency : function(num){
				if(num == estimateNullValues.min || num == estimateNullValues.max){
					return "";
				}
				return String.fromCharCode(165) + String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
			}
		};
		
		define.afterRender = function($parent, $animationTop){
			OH.setGaTrigger($parent, "vue");

      // 検索後の検索位置までのスクロール
			// if(!!$animationTop){
			// 	window.setTimeout(function(){
			// 		OH.scrollToElement($animationTop, 20);
			// 	}, 333);
			// }

		};

		define.hashPrefix = "refine:";
		
		define.firstTasks = {
			events : function(data, $parent){
				var $targetInput = $parent.find('.c-datepicker__main').eq(0);
				var availables = new Array();
				for(var i=0; i<data.length; i++){
					var splDates = data[i].dates.split(",");
					for(var j=0; j<splDates.length; j++){
						if(!splDates[j]){
							continue;
						}
						if(availables.indexOf(splDates[j]) < 0){
							availables.push(splDates[j]);
						}
					}
				}
				$targetInput.data("availables", availables.join(","));
			}
		}
		
		
		return define;
	})();
})(jQuery);
